module.exports = __webpack_public_path__ + "static/img/icon6-11.59c56bb8.png";